export enum FeeWaiversQPEnum {
    PAGE = 'page',
    SIZE = 'size',
    SORT_BY = 'sB',
    SEARCH = 'search',
    COLUMNS = 'col',
}
